import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import { titleize } from 'helpers/Formatter';
import ReportCustomizer from 'components/landlord_app/insights/components/ReportCustomizer';
import FinancialReport from 'components/landlord_app/insights/components/reporting/FinancialReport';

import { getProperties } from 'actions/landlordPropertiesActions';
import { showSecondaryLoader } from 'actions/notificationActions';
import * as insights from 'actions/insightsActions';
import { getAllAgentsAndMaintenanceForProperties } from 'actions/maintenanceActions';

import { SyncLoader } from 'halogenium';

import { CSSTransitionGroup } from 'react-transition-group';

import { toFriendlyDateString, toISO8601DateString } from 'helpers/Formatter';
import { AccentColor } from 'helpers/AccentColorHelper';

const DateRangeTitle = (reportType, startDate, endDate) => {
  const reportTypes = [
    'aged_receivables',
    'aged_payables',
    'vacancy_report',
    'rent_roll',
    'deposits_report',
    'ancillary_items',
    'resident_data_report',
    'prospect_data_report',
    'lead_marketing_report',
    'detailed_resident_data_report',
    'maintenance_work_log',
  ];
  if (!startDate) return null;

  if (reportTypes.includes(reportType)) {
    return <span>As of {toFriendlyDateString(startDate)}</span>;
  }

  if (!endDate) return null;

  if (new Date(startDate).getTime() === 0) {
    return <span>As of {toFriendlyDateString(endDate)}</span>;
  }

  return (
    <span>
      {toFriendlyDateString(startDate)} to {toFriendlyDateString(endDate)}
    </span>
  );
};

const PULL_REPORT_INTERVAL_IN_MS = 8 * 1000; // 8 seconds

export default connect(
  store => {
    return {
      showPage: store.authentication.showPage,
      properties: store.landlordProperties.properties,
      units: store.maintenanceReducer.units,
      reportData: store.insights.reportData,
      reportType: store.insights.reportType,
      dateRange: store.insights.dateRange,
      showReportLoader: store.notifications.showSecondaryLoader,
      propertyIds: store.insights.propertyIds,
      allAgentsAndMaintenance: store.maintenanceReducer.all_agents_and_maintenance_list,
    };
  },
  { showSecondaryLoader, getProperties, ...insights, getAllAgentsAndMaintenanceForProperties }
)(
  class ReportGenerator extends Component {
    componentDidMount = () => {
      this.props.getProperties({ for_multiselect: true });
    };

    generateReport = async (
      isAccrual = true,
      dateRange = this.props.dateRange,
      property_ids = this.props.propertyIds,
      transaction_ids = [],
      report_type = null,
      options = {},
      users = []
    ) => {
      if (dateRange && !dateRange['start_date']) {
        dateRange['start_date'] = toISO8601DateString(dateRange['startDate']);
        dateRange['end_date'] = toISO8601DateString(dateRange['endDate']);
      }
      const reportTypeFromQueryParam = browserHistory.getCurrentLocation().query.report_type;
      const asyncMode = browserHistory.getCurrentLocation().query.async_mode === 'true';

      let reportDetails = {
        is_accrual: isAccrual,
        date_range: dateRange,
        property_ids,
        transaction_ids,
        report_type: report_type || this.props.reportType || reportTypeFromQueryParam,
        options,
        users,
      };
      if (asyncMode) {
        try {
          const response = await this.props.postReport(reportDetails);
          this.reportPolling = this.pullReport(response.value.uuid);
        } catch (error) {
          clearInterval(this.reportPolling);
        }

        return;
      }

      this.props.reportRouter(reportDetails);
    };

    pullReport = uuid => {
      return setInterval(async () => {
        try {
          const response = await this.props.getReport(uuid);
          if (['failed', 'completed', 'created'].includes(response.value.status)) {
            clearInterval(this.reportPolling);
          }
        } catch (error) {
          clearInterval(this.reportPolling);
        }
      }, PULL_REPORT_INTERVAL_IN_MS);
    };

    render() {
      const reportType =
        this.props.reportType || browserHistory.getCurrentLocation().query.report_type;

      return (
        <div
          className="body"
          role="main"
          style={{ height: '100%', paddingLeft: '5px', paddingRight: '5px', overflow: 'hidden' }}
        >
          <div style={{ height: 'calc(100% - 100px)' }}>
            <div className="row">
              <h4 style={{ textAlign: 'center', fontSize: '20px', margin: '20px 0 3px' }}>
                {titleize(reportType.replace(/_/g, ' '))}
              </h4>
              <h5 style={{ fontFamily: 'Circular', textAlign: 'center', marginBottom: '0px' }}>
                {DateRangeTitle(
                  reportType,
                  this.props.dateRange.start_date,
                  this.props.dateRange.end_date
                )}
              </h5>
            </div>

            <CSSTransitionGroup
              transitionName="fade_out_buttons"
              transitionEnterTimeout={200}
              transitionLeaveTimeout={200}
            >
              {this.props.showReportLoader && (
                <div
                  style={{
                    position: 'absolute',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    zIndex: '500',
                    width: 'calc(100% - 30px)',
                  }}
                >
                  <div
                    style={{
                      textAlign: 'center',
                      marginTop: '30px',
                      width: '108px',
                      margin: 'auto',
                    }}
                  >
                    <SyncLoader color={AccentColor()} />
                  </div>

                  <p
                    style={{
                      textAlign: 'center',
                      marginTop: '15px',
                      marginBottom: '15px',
                    }}
                  >
                    Bear with us as we generate your report.
                  </p>
                </div>
              )}

              {!this.props.showReportLoader && (
                <div style={{ height: '100%', overflow: 'scroll' }}>
                  <ReportCustomizer
                    reportType={reportType}
                    generateReport={this.generateReport}
                    properties={this.props.properties}
                    reportData={this.props.reportData}
                    textAlign={'right'}
                    dateRange={this.props.dateRange}
                    allAgentsAndMaintenance={this.props.allAgentsAndMaintenance}
                    getAllAgentsAndMaintenanceForProperties={
                      this.props.getAllAgentsAndMaintenanceForProperties
                    }
                  />
                  <FinancialReport
                    data={this.props.reportData}
                    allTransactions={this.allTransactions}
                    generateReport={this.generateReport}
                  />
                </div>
              )}
            </CSSTransitionGroup>
          </div>
          <div style={{ height: '100px' }} />
        </div>
      );
    }
  }
);
